import { Stack, Tab, Tabs, Typography } from "@mui/material";
import { DetectiveIcon } from "@phosphor-icons/react/dist/csr/Detective";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { AccountsPage } from "./AccountsPage";
import { UsersPage } from "./UsersPage";

const AdminPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get("currentTab");
  useEffect(() => {
    if (!currentTab) {
      setSearchParams((params) => {
        params.set("currentTab", "accounts");
        return params;
      });
    }
  }, [currentTab, setSearchParams]);
  return (
    <Stack sx={{ paddingX: "132px" }}>
      <Stack direction="row" sx={{ gap: "16px", alignItems: "center" }}>
        <DetectiveIcon size="32px" />
        <Typography variant="heading.three" sx={{ color: "text50.main" }}>
          Admin
        </Typography>
      </Stack>
      <Stack sx={{ alignItems: "center" }}>
        <Tabs
          value={currentTab}
          onChange={(_, newValue) =>
            setSearchParams((params) => {
              params.set("currentTab", newValue);
              return params;
            })
          }
        >
          <Tab label="Accounts" value="accounts" />
          <Tab label="Users" value="users" />
        </Tabs>
      </Stack>
      {currentTab === "accounts" ? <AccountsPage /> : <UsersPage />}
    </Stack>
  );
};

export { AdminPage };
